<template>
<div>
    <loading v-if="loading"></loading>
    <eventPicker v-if="!loading" @select-event="selectEvent" ref="picker"></eventPicker>
</div>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import Loading from 'Site/component/Loading.vue';
import { mapActions, mapState } from 'vuex';
import EventPicker from './EventPicker.vue';

export default {
    name: 'EventInvite',
    components: {
        EventPicker,
        Loading
    },
    computed: mapState({
        eventInviteEndpoint: state => state.siteConfig.endpoints.eventInvite
    }),
    data() {
        return {
            event: {},
            loading: false
        };
    },
    methods: {
        ...mapActions(['notify']),
        invite() {
            if (this.event.id) {
                this.loading = true;
                ajax.create(this.eventInviteEndpoint.replace('0', this.event.id), {
                    user: this.invitee,
                    event: this.event.id
                }).then((response) => {
                    this.notify({ msg: response.message });
                    this.$parent.$emit('hideModal');
                    this.loading = false;
                }).catch((xhr) => {
                    const response = xhr.responseJSON;
                    if (response.message && response.message.user && response.message.user.is_invited) {
                        this.notify({ type: 'error', msg: response.message.user.is_invited });
                    } else if (response.message && response.message.user && response.message.user.is_attending) {
                        this.notify({ type: 'error', msg: response.message.user.is_attending });
                    } else {
                        this.notify({ type: 'error', msg: response.message });
                    }
                    this.loading = false;
                    this.$nextTick(() => {
                        this.$refs.picker.$emit('show');
                    });
                });
            }
        },
        selectEvent(event) {
            this.event = event;
        }
    },
    mounted() {
        this.$on('show', () => {
            this.$refs.picker.$emit('show');
        });
        this.$on('submit', this.invite);
    },
    props: {
        invitee: {
            type: Number,
            required: true
        },
        t: {
            type: Object,
            required: true
        }
    }
};

</script>
